import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { navigate, graphql, StaticQuery } from 'gatsby';
import { inject, observer } from 'mobx-react';
import { Card, CardHeader, CardContent } from '../../../../components/Card';
import { IMyStore } from '../../../../components/Card/components/CardContent/components';
import { slugFormat } from '../../../../utils/functions';
import { TypeClientStore } from '../../../SubscriptionPlans/store/selectedStore';
import { Menu } from '../../Menu';
import { formatAsideMenu } from '../../utils/formatterAdList';

interface MyAdsProps {
  name?: string;
  urlFrontagePhoto?: string;
  urlCompanyLogo?: string;
  user?: any;
  selectedStore?: TypeClientStore;
  hideMenuOnTablet?: boolean;
  isAdmin?: boolean;
  activeIndex?: number;
  activePath?: string;
  selectedVehicle?: any;
  data?: any;
}

export const _AsideMyAds = inject(
  'user',
  'selectedStore',
)(
  observer(
    ({
      name = '',
      urlCompanyLogo = '',
      urlFrontagePhoto = '',
      hideMenuOnTablet = false,
      user,
      isAdmin,
      activeIndex,
      activePath,
      selectedStore,
      data,
      selectedVehicle,
    }: MyAdsProps) => {
      const userInfo =
        user.profile.admin && selectedStore ? selectedStore.clientStore : user.profile;

      const [myStore, setMyStore] = useState<IMyStore>();
      useEffect(() => {
        const { type, name: userName, fantasyName, city, id, state } = userInfo;
        const profileName = type === 1 ? userName : fantasyName;
        const store = {
          value: 'VER MINHA LOJA',
          link: profileName ? slugFormat(`/loja/${state}/${city}/${profileName}/${id}`) : '',
        };
        setMyStore(store);
      }, []);
      const menuSettings = formatAsideMenu(
        data,
        () => {
          user.cleanUser();
          navigate('/');
        },
        selectedVehicle,
        isAdmin,
      );
      const indexByPath = menuSettings.findIndex((item: { url?: string; show: boolean }) =>
        Boolean(item.show && item.url && activePath && item.url === activePath),
      );
      const options = {
        activeIndex: indexByPath > -1 ? indexByPath : activeIndex ? activeIndex : 0,
        itemsSettings: menuSettings,
      };

      const cxMenu = cx('dn br10 br--bottom', {
        'db-ns': !hideMenuOnTablet,
        'db-m db-l': hideMenuOnTablet,
      });

      return (
        <aside className="pa0 mb48 ma0-ns pb32-ns bg-white flex-auto br10">
          <header className="br10">
            <Card hasShadow isMyAds={false}>
              <CardHeader
                isMyAds
                name={name}
                urlCompanyLogo={urlCompanyLogo}
                urlFrontagePhoto={urlFrontagePhoto}
              />
              <CardContent
                isMyAds
                myAccount="Minha conta"
                storeName={name}
                myStore={myStore}
                borderBottom={!hideMenuOnTablet}
              />
            </Card>
            <Menu options={options} className={cxMenu} />
          </header>
        </aside>
      );
    },
  ),
);

export const AsideMyAds = (props: MyAdsProps) => {
  const banners = graphql`
    query {
      allDirectusMinhaConta(filter: { minha_conta_item: { eq: "Conta" } }) {
        nodes {
          submenu_minha_conta {
            icon_submenu_minha_conta
            item_submenu_minha_conta
            url_submenu_minha_conta
            item_submenu {
              name
              url
              type
            }
          }
        }
      }
    }
  `;
  const renderAsideAds = (data: any) => {
    const {
      allDirectusMinhaConta: { nodes },
    } = data;
    return <_AsideMyAds data={nodes} {...props} />;
  };

  return <StaticQuery query={banners} render={renderAsideAds} />;
};
